import { BackIcon, CloseIcon } from './icons';
import { Box, DialogTitle, IconButton } from '@mui/material';
import { usePhoneLayout } from '../../hooks/usePhoneLayout';

export function DialogHeader({
  id,
  title,
  onClose,
  onBack,
  closeDisabled = false,
  closeLabel = 'Close',
  action,
  gap = 0.5,
}: {
  id: string;
  title: React.ReactNode;
  onClose?: () => void;
  onBack?: () => void;
  closeDisabled?: boolean;
  closeLabel?: string;
  action?: React.ReactNode;
  gap?: number;
}) {
  const phone = usePhoneLayout();
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        position: 'sticky',
        top: 0,
        flexShrink: 0,
        bgcolor: 'background.paper',
        zIndex: 2,
        borderBottom: 1,
        borderColor: 'divider',
        px: phone ? 1 : 2,
        py: 1,
        gap,
      }}
    >
      {onBack && (
        <IconButton
          aria-label="Back"
          onClick={onBack}
          sx={{ minWidth: 44, minHeight: 44 }}
        >
          <BackIcon />
        </IconButton>
      )}
      <DialogTitle
        id={id}
        sx={{
          flex: 1,
          minWidth: 0,
          px: 1,
          py: 1.5,
          fontSize: phone ? '1.125rem' : '1.25rem',
          fontWeight: 650,
          lineHeight: 1.35,
          overflowWrap: 'anywhere',
        }}
      >
        {title}
      </DialogTitle>
      {action}
      {onClose && (
        <IconButton
          aria-label={closeLabel}
          onClick={onClose}
          disabled={closeDisabled}
          sx={{ minWidth: 44, minHeight: 44, color: 'text.secondary' }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </Box>
  );
}
